import { Button, Select, Space, Typography, Flex } from "antd";
import { Link } from "react-router-dom";
import PermissionCheck from "../../../Common/PermissionCheck";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import { PermissionNames, PermissionOperations } from "~enums/permissions";

const FilterPanel = ({ setSearchText, handleStatus, searchText, status }) => {
  return (
    <Flex align="center" justify="space-between">
      <Typography.Title level={4}>
        Seasons
      </Typography.Title>
      <Space>
        <Select style={{ width: "100px" }} value={status} onSelect={handleStatus}>
          <Select.Option value={"ALL"}>ALL</Select.Option>
          <Select.Option value={"COMPLETE"}>COMPLETE</Select.Option>
          <Select.Option value={"ACTIVE"}>ACTIVE</Select.Option>
          <Select.Option value={"DRAFT"}>DRAFT</Select.Option>
          <Select.Option value={"INACTIVE"}>INACTIVE</Select.Option>
          <Select.Option value={"PENDING"}>PENDING</Select.Option>
        </Select>
        <SearchFilter searchValue={searchText} doSearch={setSearchText} />
        <PermissionCheck permissionKeys={[PermissionNames.SEASON]} permissionOptions={[PermissionOperations.CREATE]}>
          <Link to={`add`}>
            <Button type="primary" icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />}>
              Season
            </Button>
          </Link>
        </PermissionCheck>
      </Space>
    </Flex>
  );
};

export default FilterPanel;
